import { PriceCalcFailedReason, Product } from "types";

/**
 * Eine Karte gilt als erfolgreich bepreist, wenn die letzte Berechnung einen
 * Ladenpreis geliefert hat ODER ein Preis manuell gepflegt wurde. Genau diese
 * Bedingung steuert das grüne Häkchen bzw. das rote Kreuz in der Kartenliste.
 *
 * Zentral, weil Icon, Filter und Sortierung vorher auseinanderliefen: der Filter
 * prüfte nur lastStorePriceCalcSuccess und widersprach dem Icon bei allen
 * manuell gepflegten Karten.
 */
export const isProductPriceSuccessful = (
  product: Pick<Product, "lastStorePriceCalcSuccess" | "priceStoreSetManually">,
) => product.lastStorePriceCalcSuccess || product.priceStoreSetManually;

export const isProductPriceFailed = (
  product: Pick<Product, "lastStorePriceCalcSuccess" | "priceStoreSetManually">,
) => !isProductPriceSuccessful(product);

/**
 * Gründe, bei denen eine Neuberechnung nichts bringt: am Markt gibt es keine
 * verwertbaren Angebote, daran ändert ein weiterer Versuch nichts.
 */
export const HOPELESS_PRICE_CALC_FAILED_REASONS: PriceCalcFailedReason[] = [
  "NoArticlesFound",
];

/**
 * Karten, für die eine erneute Berechnung sinnvoll ist: fehlgeschlagen, aktiv,
 * und der Grund war nicht "keine Angebote am Markt". Ein Grund von null bedeutet
 * "nie bearbeitet" (Lauf abgebrochen oder in den Timeout gelaufen) und wird
 * bewusst mitgenommen.
 */
export const isProductPriceRetryable = (product: Product) =>
  isProductPriceFailed(product) &&
  product.isProductActive &&
  !(
    product.lastPriceCalcFailedReason &&
    HOPELESS_PRICE_CALC_FAILED_REASONS.includes(
      product.lastPriceCalcFailedReason,
    )
  );
